import type { ParticipantId, WallId } from '@walls/store/types';

export const accessTokenKey = 'dotstorming_access_token';
export const refreshTokenKey = 'dotstorming_refresh_token';

export const readStorageValue = (key: string) => {
  if (typeof window === 'undefined') {
    return null;
  }

  const value = window.localStorage.getItem(key)?.trim() ?? '';
  return value.length > 0 ? value : null;
};

export const writeStorageValue = (key: string, value: string | null) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!value) {
    window.localStorage.removeItem(key);
    return;
  }

  window.localStorage.setItem(key, value);
};

export const clearAuthTokens = () => {
  writeStorageValue(accessTokenKey, null);
  writeStorageValue(refreshTokenKey, null);
};

export const wallStorage = {
  getTopicKey(boardId: WallId) {
    return readStorageValue(`dotstorming_topic_key_${boardId}`);
  },

  setTopicKey(boardId: WallId, key: string) {
    writeStorageValue(`dotstorming_topic_key_${boardId}`, key);
  },

  clearTopicKey(boardId: WallId) {
    writeStorageValue(`dotstorming_topic_key_${boardId}`, null);
  },

  getTopicUser(boardId: WallId) {
    return readStorageValue(`dotstorming_topic_user_${boardId}`);
  },

  setTopicUser(boardId: WallId, participantId: ParticipantId) {
    if (typeof window === 'undefined') {
      return;
    }

    window.localStorage.setItem(`dotstorming_topic_user_${boardId}`, participantId);
  },

  clearTopicUser(boardId: WallId) {
    if (typeof window === 'undefined') {
      return;
    }

    window.localStorage.removeItem(`dotstorming_topic_user_${boardId}`);
  },

  getUserName() {
    return readStorageValue('dotstorming_user_name');
  },

  setUserName(name: string) {
    if (typeof window === 'undefined') {
      return;
    }

    window.localStorage.setItem('dotstorming_user_name', name);
  },

  clearAuth() {
    if (typeof window === 'undefined') {
      return;
    }

    window.localStorage.removeItem('dotstorming_access_token');
    window.localStorage.removeItem('dotstorming_refresh_token');
    window.localStorage.removeItem('dotvoting_user');
    window.localStorage.removeItem('dotstorming_user_name');

    Object.keys(window.localStorage).forEach((key) => {
      if (key.startsWith('dotstorming_topic_user_') || key.startsWith('dotstorming_topic_key_')) {
        window.localStorage.removeItem(key);
      }
    });
  },
};
